export default "__VITE_ASSET__81051691__"